
var initialState =
{
   index:0,
   title:"",
   nextSlideAvalaible:true,
    previousSlideAvalaible: true,
    positioningSkipped: false,
   language: "fi",
   instructionModalVisible: false,
   displayError: false,
   errorMessage: "",
   materialImageShown: false
}




const ui = (state=initialState, action) => {
  switch (action.type) {
      case 'mainSlideChanged':
          return Object.assign({}, state, {
              index: action.index,
              title: action.title,
              nextSlideAvalaible: action.nextSlideAvalaible,
              previousSlideAvalaible: action.previousSlideAvalaible,
              materialImageShown: action.materialImageShown
          });
      case 'CLOSE_INSTRUCTION_MODAL':         
              return Object.assign({}, state, {
                  instructionModalVisible: false
              });
      case 'SHOW_INSTRUCTION_MODAL':
          return Object.assign({}, state, {
              instructionModalVisible: true
          });
      case 'CHANGE_LANGUAGE':
          return Object.assign({}, state, {
              language: action.language
          });          
      case 'SHOW_ALERT':
          return Object.assign({}, state, {
              alertMessage: action.alertMessage,
              showAlert: true
          });
      case 'HIDE_ALERT':
          return Object.assign({}, state, {
          showAlert: false
          });
      case 'DISPLAY_ERROR':
          return Object.assign({}, state, {
              displayError: action.displayError,
              errorMessage: action.errorMessage
          });
      case 'MEASUREMENTS_SKIPPED':
          return Object.assign({}, state, {
              positioningSkipped: true
          })
      case 'MEASUREMENTS_GIVEN':
          return Object.assign({}, state, {
              positioningSkipped: false
          })

    default:
      return state
  }
}
export default ui
